<template>
  <div class="page-container">
    <div class="header">
      <el-tabs v-model="tabVal" @tab-click="handleTabClick">
        <el-tab-pane
          v-for="(item, index) in mapPaymentType"
          :key="index"
          :label="item.label"
          :name="item.value"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <div class="search-area">
      <el-form inline label-width="90px">
        <template v-for="(item, index) in searchConfig">
          <el-form-item
            :key="index"
            :label="item.label"
            size="small"
            v-if="!item.needHeadShop || isHeadShop"
          >
            <el-input v-if="item.kind === 'input'" v-model="searchForm[item.bind]"
                      class="search-input" :placeholder="`请输入${item.label}`" @input="(e)=>handleInputChange(e,item.label)" />
            <el-select
              v-else-if="item.kind === 'select'"
              v-model="searchForm[item.bind]"
              class="search-input"
              :filterable="item.filterable || false"
              :placeholder="`请选择${item.label}`"
            >
              <el-option v-if="!item.filterable" label="全部" value="" />
              <el-option v-for="(value, key, index) in item.options" :key="index" :value="Number(key)" :label="value" />
            </el-select>
            <CommonSelect
              v-else-if="item.kind === 'commonSelect'"
              v-model="searchForm[item.bind]"
              :ref="`${item.bind}CommonSelect`"
              :placeholder="`请选择${item.label}`"
              :needPaging="true"
              :needRemote="true"
              :remoteConfig="item.remoteConfig"
              :need-all="true"
            />
            <DateTimeRangePicker
              v-else-if="item.kind === 'date'"
              ref="dateRangePicker"
              :type="item.type"
              :maxRange="item.maxRange || ''"
              :earliestDate="item.earliestDate || null"
              :shortcutArr="item.shortcutArr"
              :startTime.sync="searchForm[item.bind[0]]"
              :endTime.sync="searchForm[item.bind[1]]"
              @quickSelect="handleQuickSelect"
            />
          </el-form-item>
          <br :key="index + 'br'" v-if="item.withBr" />
        </template>
        <el-form-item size="small">
          <el-button class="bs-btn" :loading="table.loading" @click="handleSearch">查询</el-button>
          <el-button class="bs-btn2" @click="handleReset">重置</el-button>
          <el-button class="bs-btn" :loading="exportLoading" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="isHeadShop" class="remind-area">温馨提示: 筛选条件选择全部门店时，仅支持导出，不支持查询。</div>
    <div class="table-area">
      <el-table border style="width: 100%;" v-loading="table.loading" :data="table.data">
        <el-table-column
          v-for="(item, index) in table.columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minWidth || '180'"
          :formatter="item.formatter"
          align="center"
        />
      </el-table>
      <el-col :span="24" class="btm-action">
        <el-pagination
          v-if="table.count > 0"
          class="pagination"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.count"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"
        />
      </el-col>
    </div>
  </div>
</template>

<script>
/* eslint-disable object-curly-newline */
import moment from 'moment';
import DateTimeRangePicker from '@/components/dateTimeRangePicker.vue';
import CommonSelect from '@/components/CommonSelect.vue';
import { getListPayBill, downloadPayBill } from '@/api/payment';

// 枚举
const mapStatus = {
  [-1]: '打款失败',
  0: '打款中',
  1: '打款成功',
  2: '打款退票',
  3: '冻结出款',
};

export default {
  name: 'payment-records',
  components: {
    DateTimeRangePicker,
    CommonSelect,
  },
  data() {
    return {
      mapPaymentType: [
        { value: '1', label: 'D1打款记录' },
        { value: '0', label: 'D0打款记录' },
        { value: '2', label: '手续费补贴打款记录' },
      ],
      tabVal: '1',
      searchConfig: [
        { kind: 'date', label: '打款日期', bind: ['startTime', 'endTime'], type: 'daterange', shortcutArr: ['今天', '本周', '本月'], earliestDate: moment().subtract(3, 'month'), withBr: true },
        { kind: 'input', label: '打款单号', bind: 'billId' },
        { kind: 'select', label: '打款状态', bind: 'status', options: mapStatus },
        { kind: 'input', label: '乐刷商户号', bind: 'targetMerchantId' },
        { kind: 'commonSelect', label: '门店', bind: 'shopId', needHeadShop: true, remoteConfig: { quickRemoteLabel: 'shop', defaultSelectIndex: 0 } }, // TODO 总店账号展示该查询条件，分店账号不展示该查询条件
      ],
      searchForm: {
        startTime: '',
        endTime: '',
        billId: '',
        status: '',
        targetMerchantId: '',
        shopId: '',
        type: 1,
      },
      exportLoading: false,

      table: {
        loading: false,
        columns: [
          { label: '发起打款时间', prop: 'billCreateTime' },
          { label: '打款单号', prop: 'billId' },
          { label: '打款金额(元)', prop: 'amount' },
          { label: '打款状态', prop: 'status', formatter: item => mapStatus[item.status] },
          { label: '打款失败原因', prop: 'failReason' },
          { label: '乐刷商户号', prop: 'merchantId' },
          { label: '门店简称', prop: 'merchantName' },
          { label: '结算类型', prop: 'type' },
          { label: '结算款项', prop: 'settlementAgency' },
          { label: '收款人', prop: 'bankHolder' },
          // { label: '收款银行', prop: 'bankName' },
          { label: '收款卡号', prop: 'bankAccount' },
          { label: '打款备注', prop: 'remark' },
        ],
        data: [],
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    actualParams() {
      const { startTime, endTime } = this.searchForm;
      return {
        ...this.searchForm,
        startTime: startTime ? `${startTime} 00:00:00` : startTime,
        endTime: endTime ? `${endTime} 23:59:59` : endTime,
      };
    },
    loginInfo() {
      const str = localStorage.getItem('LOGIN_INFO');
      return JSON.parse(str);
    },
    isHeadShop() { // 当前是否为总店登录
      return this.loginInfo.shopType === 1;
    },
    shopId() { return this.searchForm.shopId; },
  },
  watch: {
    shopId(newVal, oldVal) {
      console.log('[watch] shopId:', newVal);
      if (newVal && !oldVal) {
        this.searchForm.targetMerchantId = "";
        this.handleSearch();
      }
    },
    loginInfo: {
      handler(val) {
        this.searchForm.targetMerchantId = val.shopType !== 1 ? val.merchantId : '';
      },
      immediate: true,
    },
  },
  methods: {
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableList();
    },

    handleTabClick({ name }) {
      this.searchForm.type = Number(name);
      this.handleSearch();
    },

    handleSearch() {
      if (this.searchForm.targetMerchantId === "" && this.searchForm.shopId === "" && this.isHeadShop) {
        this.$message.warning("筛选条件选择全部门店不支持查询");
        return;
      }
      this.table.pageNo = 1;
      this.queryTableList();
    },

    handleQuickSelect() {
      if (this.shopId) {
        this.handleSearch();
      }
    },

    handleReset() {
      this.searchForm = this.$options.data().searchForm;
      this.searchForm.type = Number(this.tabVal);
      if (this.isHeadShop) {
        this.searchForm.shopId = (this.$refs.shopIdCommonSelect[0].remoteInfo.list[0] || { value: '' }).value;
      }
      this.$refs.dateRangePicker[0].handleQuickTimePickerChange(0);
    },

    handleExport() {
      // 两个日期
      const date1 = moment(this.searchForm.startTime);
      const date2 = moment(this.searchForm.endTime);
      // 计算两个日期之间的差距
      const diff = date2.diff(date1, 'days');
      if (this.searchForm.shopId === "" && diff > 31) {
        this.$message.warning("全部门店导出，请选择31日（含）内时间");
        return;
      }
      this.exportLoading = true;
      downloadPayBill({ ...this.actualParams }).then((res) => {
        const { code, msg } = res.data;
        if (String(code) === '0') {
          this.$message.success('导出成功，请到下载中心下载报表文件！');
        }
      }).finally(() => { this.exportLoading = false; });
    },

    queryTableList() {
      console.log('queryTableList');
      this.table.loading = true;
      const { pageNo, pageSize } = this.table;
      getListPayBill({ ...this.actualParams, pageNo, pageSize }).then((res) => {
        const { code, msg, data } = res.data;
        if (String(code) === '0') {
          this.table.data = data.list;
          this.table.count = data.totalCount;
        }
      }).finally(() => { this.table.loading = false; });
    },

    handleInputChange(value, name) {
      if (name === "乐刷商户号") {
        this.searchForm.shopId = "";
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.page-container {
  background-color: #f7f7f7;

  .header {
    display: flex;
    align-items: center;
    height: 80px;
    padding-left: 50px;
    background-color: #fff;
    border-bottom: 1px solid #f2f3f3;

    /deep/ .el-tabs {
      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__header {
        height: 80px;
        margin-bottom: 0;

        .el-tabs__item {
          box-sizing: border-box;
          height: 80px;
          font-size: 18px;
          line-height: 80px;
          color: #333;
        }
      }
    }
  }

  .search-area {
    margin-top: 40px;
    margin-left: 40px;
  }

  .remind-area {
    margin-top: 40px;
    margin-left: 40px;
    color: red;
  }

  .table-area {
    margin-top: 40px;
    margin-left: 40px;

    .btm-action {
      margin-top: 20px;
      text-align: center;
    }
  }
}

/deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
  box-shadow: none;
}
</style>
